// extracted by mini-css-extract-plugin
export var deliveryRow = "_ms-a";
export var fixedHeight = "_ms-4";
export var freightLogo = "_ms-9";
export var fullWidth = "_ms-3";
export var priceColumn = "_ms-5";
export var radioSelected = "_ms-7";
export var radioUnselected = "_ms-6";
export var selectedOption = "_ms-2";
export var selectedOptionContainer = "_ms-1";
export var selection = "_ms-0";
export var tallSkeletonText = "_ms-8";